"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const scale_1 = require("../../utils/scale");
const CustomText_1 = __importDefault(require("../text/CustomText"));
const LinkButton = (props) => {
    const { title, style = {}, textStyle = {}, onPress, disabled = false } = props;
    return (react_1.default.createElement(react_native_1.Pressable, { onPress: onPress, 
        // @ts-ignore
        style: ({ hovered, pressed }) => [
            styles.button,
            (hovered || pressed) && styles.buttonActive,
            disabled && { backgroundColor: '' },
            style,
        ], disabled: disabled },
        react_1.default.createElement(CustomText_1.default, { style: [styles.text, textStyle, disabled && { color: '#007affb3' }] }, title)));
};
exports.default = LinkButton;
const styles = react_native_1.StyleSheet.create({
    // @ts-ignore
    button: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderBottomColor: 'transparent',
        ...react_native_1.Platform.select({
            web: {
                width: 'fit-content',
                transitionProperty: 'all',
                transitionDuration: '300ms',
                transitionTimingFunction: 'ease',
            },
        }),
    },
    text: {
        fontSize: (0, scale_1.moderateScale)(15),
        lineHeight: (0, scale_1.moderateScale)(18),
        color: '#007AFF',
    },
    buttonActive: {
        borderBottomWidth: 1,
        borderBottomColor: '#007AFF',
    },
});
